import React, { useState } from 'react'
import axios from 'axios'
import { useRouter } from 'next/router'

import NarrowContainer from 'containers/NarrowContainer'

import Button from 'components/Button'
import FormattedMessage from 'components/FormattedMessage'
import Hint from 'components/Hint'
import Form from 'components/Form'
import FormItem from 'components/Form/Item'
import Input from 'components/Form/Input'

import './index.less'

const RequestResetPassword = () => {
  const [isSubmitting, setIsSubmitting] = useState(false)
  const [errors, setErrors] = useState()
  const { query } = useRouter()

  const submitHandler = (values) => {
    setIsSubmitting(true)
    setErrors(null)

    axios.post('/password.json', {
      user: {
        email: values.email,
      },
      redirect_path: query.redirect_path,
    })
      .then(() => {
        window.location.href = '/login'
      })
      .catch((error) => {
        setIsSubmitting(false)
        setErrors(error.response.data.errors)
      })
  }

  return (
    <NarrowContainer className="users users--request-password simple-form-layout">
      <h1 className="simple-form-layout__title">
        <FormattedMessage id="users.requestPassword.title" />
      </h1>

      {errors && (
        <Hint
          variant="error"
          modifiers={['bold']}
          className="simple-form-layout__hint"
        >
          {Object.keys(errors).map((key) => (
            errors[key] && errors[key][0] && (
              <div key={key}>{errors[key][0]}</div>
            )
          ))}
        </Hint>
      )}

      <Form onSubmit={submitHandler}>
        <FormItem
          name="email"
          label={<FormattedMessage id="users.requestPassword.email" />}
          className="simple-form-layout__item"
        >
          <Input
            name="email"
            defaultValue={query.email}
            className="simple-form-layout__item__input"
            rules={{ required: <FormattedMessage id="errors.empty" /> }}
          />
        </FormItem>

        <FormItem className="simple-form-layout__item simple-form-layout__item--submit">
          <Button
            translationKey="users.requestPassword.submit"
            type="primary"
            size="large"
            htmlType="submit"
            className="ant-btn--with-border-radius-large ant-btn--brand-font"
            disabled={isSubmitting}
          />
        </FormItem>
      </Form>

      <div className="simple-form-layout__footer">
        <FormattedMessage
          id="users.requestPassword.alreadyHavePassword"
          values={{ login: (chunks) => <a className="link" href="/login">{chunks}</a> }}
        />
      </div>
    </NarrowContainer>
  )
}

export default RequestResetPassword
